import Phs from "../";

const routes = [
  {
    name: "PhsLogsListPage",
    path: "/phslogs",
    component: Phs.PhsLogsListPage,
    meta: { title: "Logs" },
  },
];

export default routes;
